import { render, staticRenderFns } from "./PeriodicNameEdit.vue?vue&type=template&id=1faf5cf8&"
import script from "./PeriodicNameEdit.js?vue&type=script&lang=js&"
export * from "./PeriodicNameEdit.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports